"use strict";

import Vue from "vue";
import axios from "axios";
import store from "../store";
import router from "../router";

const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.VUE_APP_PRODUCTION_URL
    : process.env.VUE_APP_STAGING_URL;

let config = {
  baseURL: baseURL,
  //timeout: 60 * 5000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    const token = store.state.auth.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    response = response.data;
    // Do something with response data
    return response;
  },
  async function (error) {
    // Do something with response error
    console.log(error.response.status);
    if (error.response.status === 401) {
      store.commit("auth/LOGOUT");
      const route = document.location.pathname;
      await router.push({
        path: "/login",
        query: { redirect: route },
      });
    }
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
